// extracted by mini-css-extract-plugin
module.exports = {"container":"_1IBeU5NZ6Dc5ybhWDcETaj","icon":"_15auCcSELsZ2XRUrMLzVpC"};